// extracted by mini-css-extract-plugin
module.exports = {"active":"nav-bar-routes_active_3EAeb"};